import { AllThingsList } from "components/thing";
export default AllThingsList;
